// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__3Q9WQ","text":"style_text__2dixD","poweredImg":"style_poweredImg__3UQtm"};